const imageNotFound = 'https://firebasestorage.googleapis.com/v0/b/icollect-845b0.appspot.com/o/images%2Fcollections%2Ffcc8dc3f-21cc-412f-a899-d70bcd23a320Frame%2061.png?alt=media&token=91137ce0-b4b5-4799-8c2d-0308a5ea2dca';

export default imageNotFound;